import { mergeQueryString } from 'bernie-core';

import { SortAndFiltersParamsKeys, SortAndFiltersRangeParamKey } from '@shared-ui/search-tools-lodging';

import { parse } from 'query-string';

export interface Categories {
  destination: any;
  criteria: any;
  shoppingContext: {
    multiItem: {
      id: string;
      packageType: string;
    };
  };
}

const universalSortFilterKeys = [...Object.values(SortAndFiltersParamsKeys), ...Object.values(SortAndFiltersRangeParamKey)];
const universalSortFilterPriceKey = Object.values(SortAndFiltersRangeParamKey);

export const mergeQueryKey = (key, name) => !key.startsWith(name);
export const mapValue = prevValue => prevValue;
export const filterValue = (prevValue, value) => prevValue !== value;
// keeps keys that are not universal sort and filter keys
const keepNonUniversalSortFilterKeys = key => !universalSortFilterKeys.includes(key);

// keeps keys other then universal sort and filter price key
const shouldRemoveUniversalSortFiltersPriceKey = key => !universalSortFilterPriceKey.includes(key);

// eslint-disable-next-line complexity
export const buildUrlQueryString = ({ name, value, existingUrlQueryString }): string => {
  let resultingUrlQueryString;
  let newUrlQueryParameters;
  const parsedUrlQueryString = parse(existingUrlQueryString);
  switch (name) {
    case 'clear':
      // takes the existing query string and filters out USF filters
      resultingUrlQueryString = mergeQueryString(existingUrlQueryString, {}, keepNonUniversalSortFilterKeys);

      return resultingUrlQueryString;

    case 'restore':
      return '';

    case 'propertyName':
      newUrlQueryParameters = { hotelName: value.hotelName, selected: value.selected };
      resultingUrlQueryString = mergeQueryString(existingUrlQueryString, {}, mergeQueryKey.bind(null, name));
      resultingUrlQueryString = mergeQueryString(existingUrlQueryString, newUrlQueryParameters);

      return resultingUrlQueryString;

    case 'regionId':
      newUrlQueryParameters = { regionId: value, neighborhood: value };
      resultingUrlQueryString = mergeQueryString(existingUrlQueryString, {}, mergeQueryKey.bind(null, name));
      resultingUrlQueryString = mergeQueryString(existingUrlQueryString, newUrlQueryParameters);

      return resultingUrlQueryString;

    case 'nightly_price':
    case 'total_price':
    case 'price': {
      if (value.min === -1 && value.max === -1) {
        resultingUrlQueryString = mergeQueryString(existingUrlQueryString, {}, shouldRemoveUniversalSortFiltersPriceKey);

        return resultingUrlQueryString;
      }
      resultingUrlQueryString = mergeQueryString(existingUrlQueryString, {}, mergeQueryKey.bind(null, name));

      return resultingUrlQueryString.concat(`&${name}=${value.min}`).concat(`&${name}=${value.max}`);
    }

    case 'star':
    case 'paymentType':
    case 'lodging':
    case 'bedroomFilter':
    case 'mealPlan':
    case 'amenities':
    case 'rewards':
    case 'travelerType':
    case 'accessibility':
    case 'availableFilter':
    case 'property_type_group':
    case 'accessibility_features_group':
    case 'booking_options_group':
    case 'discounts_group':
    case 'amenities_facilities_group':
    case 'free_cancellation_group':
    case 'house_rules_group':
    case 'nearby_activities_group':
    case 'neighborhood_group':
    case 'premier_host_group':
    case 'properties_good_for_group':
    case 'property_reviews_group':
    case 'rooms_spaces_group':
    case 'safety_group':
    case 'virtual_tour_group':
    case 'location_group': {
      let currentValue = parsedUrlQueryString[name] ?? [];

      if (currentValue.includes(value)) {
        currentValue = Array.isArray(currentValue) ? currentValue.filter(filterValue.bind(null, value)).map(mapValue) : [];

        newUrlQueryParameters = { [name]: currentValue };
        resultingUrlQueryString = mergeQueryString(existingUrlQueryString, newUrlQueryParameters);

        return resultingUrlQueryString;
      }

      resultingUrlQueryString = mergeQueryString(existingUrlQueryString, {});
      resultingUrlQueryString = resultingUrlQueryString.concat(`&${name}=${value}`);

      return resultingUrlQueryString;
    }
    default:
      newUrlQueryParameters = { [name]: value };
      resultingUrlQueryString = mergeQueryString(existingUrlQueryString, {}, mergeQueryKey.bind(null, name));
      resultingUrlQueryString = mergeQueryString(existingUrlQueryString, newUrlQueryParameters);

      return resultingUrlQueryString;
  }
};
